import types from '../eventsActions';
import { analyticsListNames } from '../constant';

const _ = (data: any, list: string) => {
  return data.map((product: any, index: number) => {
    return {
      name: `${product.manufacturerCode}  ${product.productNumber}`,
      id: `${product.manufacturerCode}  ${product.productNumber}`,
      price: product.partnerPrice,
      brand: product.manufacturerCode,
      list,
      position: index + 1
    };
  });
};

const areProductsLoaded = (productsExtracted: any) => {
  for (const product of productsExtracted) {
    if (product.productDetailsState !== 'loaded') {
      return false;
    }
  }
  return true;
};

const deduceDatalayer = (data: any, event: string) => {
  let dataLayerObject: any = [];
  let dataLayer = {};
  const productsExtracted: any = [];

  data.diagrams.forEach((diagram: any) => {
    diagram.products.forEach((product: any) => {
      productsExtracted.push(product);
    });
  });
  const productsLoaded = areProductsLoaded(productsExtracted);
  if (productsLoaded) {
    dataLayerObject = _(productsExtracted, data.list);
    dataLayer = {
      event,
      ecommerce: {
        list: data.list,
        listCriteria: data.model,
        listPage: data.page ? data.page : 1,
        additionalCriteria: data.modelManufacturer,
        impressions: [...dataLayerObject]
      }
    };
  } else {
    return { dataLayer, impressionSent: false };
  }

  return { dataLayer, impressionSent: dataLayerObject.length !== 0 };
};

export default (payload: any, type: string, state: any) => {
  let dataLayerObject = {};
  switch (type) {
    case types.SEND_MODEL_PRODUCT_IMPRESSION:
      if (state.model !== payload.model) {
        return { ...state, model: payload.model, impressionSent: false };
      } else if (state.model === payload.model && !state.impressionSent) {
        const data = {
          ...payload,
          modelManufacturer: state.modelManufacturer || ''
        };
        dataLayerObject = deduceDatalayer(data, types.PRODUCT_IMPRESSIONS);
        if (Object.keys(dataLayerObject['dataLayer']).length === 0) {
          return { ...state, model: '' };
        } else {
          window['dataLayer'].push(dataLayerObject['dataLayer']);
          return {
            ...state,
            model: payload.model,
            impressionSent: dataLayerObject['impressionSent'],
            listName: payload.list,
            diagramAndImpression: { [-1]: dataLayerObject['dataLayer'] }
          };
        }
      }
      return { ...state, model: payload.model };
    case types.STORE_MODEL_DIAGRAM_PRODUCT_DATA:
      if (
        state.activeDiagram !== -1 &&
        state.activeDiagram !== state.lastActiveDiagram
      ) {
        const diagramSelected = payload.allModelProducts.find(
          (diagram: any) => diagram.diagramId === state.activeDiagram
        );
        const data = {
          diagrams: [diagramSelected],
          model: state.model + ' > ' + diagramSelected.diagramName,
          list: analyticsListNames.LIST_BY_MODEL_DIAGRAM,
          page: 1,
          modelManufacturer: state.modelManufacturer || ''
        };
        dataLayerObject = deduceDatalayer(data, types.PRODUCT_IMPRESSIONS);
        if (Object.keys(dataLayerObject['dataLayer']).length === 0) {
          return { ...state };
        } else {
          window['dataLayer'].push(dataLayerObject['dataLayer']);
          return {
            ...state,
            lastActiveDiagram: state.activeDiagram,
            listName: data.list,
            diagramAndImpression: {
              ...state.diagramAndImpression,
              [state.activeDiagram]: dataLayerObject['dataLayer']
            }
          };
        }
      }
      return { ...state };
    case types.SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION:
      let impression: any = { found: false, dataLayer: {} };
      for (const diagram in state.diagramAndImpression) {
        if (parseInt(diagram, 10) === payload) {
          impression = {
            found: true,
            dataLayer: state.diagramAndImpression[diagram]
          };
          break;
        }
      }
      if (impression.found) {
        delete impression.dataLayer['gtm.uniqueEventId'];
        window['dataLayer'].push(impression.dataLayer);
        return { ...state };
      } else {
        return { ...state, activeDiagram: payload };
      }
    default:
      return { ...state };
  }
};
